import React, { useEffect, useState } from "react";
import TauriImage from "../TauriImage/TauriImage";
import "./OpalRadialMenu.css";
import OpalForAcknowledementModal from "../OpalCoverageLayout/CoverageView/OpalSamples/OpalForAcknowledementModal/OpalForAcknowledementModal";
import appURL from '../../appURL.json';
import { useBaseProvider } from "../../BaseManager/BaseManager";

const OpalRadialMenu = () => {
    const [open, setOpen] = useState(false);
    const [activeComponent, setActiveComponent] = useState(null);
    const [counts, setCounts] = useState({
        acknowledgement: 0
    });

    const storedPermission = localStorage.getItem("permission");
    const permission = JSON.parse(atob(storedPermission));

    const { signalRConnection } = useBaseProvider();

    useEffect(() => {
        if (!signalRConnection) return;

        const handleForAcknowledgementSignalR = async (extID) => {
            if (!extID) return;

            await updateAcknowledgementCount()
        };

        signalRConnection.on("ForAcknowledgement", handleForAcknowledgementSignalR);

        return () => {
            signalRConnection.off("ForAcknowledgement", handleForAcknowledgementSignalR);
        };
    }, [signalRConnection]);

    const componentMap = {
        acknowledgement: OpalForAcknowledementModal,
    };

    const items = [
        {
            icon: "/Images/outline-inventory.svg",
            name: "For Acknowledgement",
            action: "acknowledgement",
            show: permission?.coverage?.samples,
            count: counts.acknowledgement
        },
    ];

    useEffect(() => {
        const handler = () => updateAcknowledgementCount();

        window.addEventListener("refreshAcknowledgement", handler);
        return () => window.removeEventListener("refreshAcknowledgement", handler);
    }, []);

    const fetchAcknowledgementCount = async () => {
        try {
            const isOnline = JSON.parse(localStorage.getItem("isOnline"));
            const hasInternet = navigator.onLine;

            if (isOnline && hasInternet) {
                const token = localStorage.getItem("token");
                const devId = localStorage.getItem("devId");

                const response = await fetch(`${appURL.API_Acknowledgement}/pending`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        "X-ETR-Device-ID": devId
                    },
                });

                if (!response.ok) return 0;

                const res = await response.json();

                return (res?.stocks || []).length;
            }

            return 0;
        } catch (error) {
            return 0;
        }
    };

    const updateAcknowledgementCount = async () => {
        const count = await fetchAcknowledgementCount();

        setCounts(prev => ({
            ...prev,
            acknowledgement: count
        }));
    };

    useEffect(() => {
        updateAcknowledgementCount();
    }, []);

    const visibleItems = items.filter(item => item.show);

    const radius = 110;
    const startAngle = -90;
    const endAngle = -180;

    const openIcon = "/Images/material-symbols--close.svg";
    const mainIcon = "/Images/uil--plus.svg";

    const handleClick = (item) => {
        if (item.action) {
            setActiveComponent(item.action);
        }
        setOpen(false);
    };

    const ActiveComponent = componentMap[activeComponent];

    const totalBadgeCount = Object.values(counts).reduce((sum, val) => sum + (val || 0), 0);

    if (visibleItems.length === 0) {
        return null;
    }

    return (
        <div className="opal-radial-menu">
            <button className="main-btn" onClick={() => setOpen(!open)}>
                <span className={`icon ${open ? "open" : ""}`}>
                    <TauriImage
                        localImage={open ? openIcon : mainIcon}
                        alt="main"
                        color="#1D5D9B"
                    />
                </span>
                {totalBadgeCount > 0 && (
                    <span className="badge main-badge">
                        {totalBadgeCount > 99 ? "99+" : totalBadgeCount}
                    </span>
                )}
            </button>

            {visibleItems.map((item, index) => {
                const angle =
                    visibleItems.length === 1
                        ? (startAngle + endAngle) / 2
                        : startAngle +
                        (index / (visibleItems.length - 1)) * (endAngle - startAngle);

                const x = radius * Math.cos((angle * Math.PI) / 180);
                const y = radius * Math.sin((angle * Math.PI) / 180);

                return (
                    <button
                        key={index}
                        className="radial-item"
                        onClick={() => handleClick(item)}
                        style={{
                            transform: open
                                ? `translate(${x}px, ${y}px)`
                                : `translate(0, 0)`,
                            opacity: open ? 1 : 0,
                            pointerEvents: open ? "auto" : "none",
                        }}
                    >
                        <span className="item-icon">
                            <TauriImage
                                localImage={item.icon}
                                alt={item.name}
                                color="#1D5D9B"
                            />
                            {item.count > 0 && (
                                <span className="badge">
                                    {item.count > 99 ? "99+" : item.count}
                                </span>
                            )}
                        </span>
                        <span className="tooltip">{item.name}</span>
                    </button>
                );
            })}

            {ActiveComponent && (
                <ActiveComponent
                    show={true}
                    onHide={() => setActiveComponent(null)}
                />
            )}
        </div>
    );
};

export default OpalRadialMenu;